<template>
  <v-card width="700" height="350" flat>
    <v-carousel
      :continuous="false"
      :show-arrows="false"
      delimiter-icon="mdi-circle"
      hide-delimiter-background
      height="400"
      class="secundary5 mt-n5"
    >
      <v-carousel-item v-for="(list, index) in coList" :key="index">
        <v-sheet class="d-flex justify-space-around secundary5">
          <v-data-table
            :headers="headersTable"
            :items="co.group"
            hide-default-footer
            dense
            class="d-flex flex-wrap justify-space-around elevation-1 mt-1"
            @click:row="clickTo"
            v-for="(co, index) in list.correctors"
            :key="index"
          >
          </v-data-table>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <v-card-actions class="d-flex justify-center mt-n2">
      <v-row class="d-flex justify-center mx-3" v-if="observerHCP === false">
        <v-col xs="6" class="d-flex justify-start ml-9 mt-n1">
          <v-dialog-co-key
            :dialogItem="slideDialogItem"
            :dialog="dialog"
            :uploadFileLLaveCo="uploadFileLLaveCo"
            :confirmUploadFileLLaveCo="confirmUploadFileLLaveCo"
            :nameLLaveCo="nameLLaveCo"
            :deleteLlaveCo="deleteLlaveCo"
            :handleEvents="handleEvents"
            style="z-index: 1"
          />
        </v-col>
        <v-col xs="6" class="d-flex flex-xs-wrap justify-end pa-0">
          <v-btn
            text
            class="grey lighten-3 px-1 mr-3"
            style="box-shadow: none; z-index: 1"
            @click="insertRoute(item.to)"
            v-for="(item, index) in coBtnIcons"
            :key="index"
            :disabled="true"
          >
            <v-icon class="primary--text mr-1" size="30">{{ item.icon }}</v-icon>
            <span class="primary--text text-body-2 text-capitalize">{{ item.name }}</span>
            <v-chip class="primary3--text grey lighten-3 text-lowercase px-0 mb-4" x-small>
              pronto
            </v-chip>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import VDialogCoKey from '@/components/base/VDialogCoKey.vue';

export default {
  name: 'VSlidesCorrectors',
  components: {
    VDialogCoKey,
  },
  props: [
    'headersTable',
    'coList',
    'coBtnAdd',
    'coBtnIcons',
    'slideDialogItem',
    'clickTo',
    'handleEvents',
    'uploadFileLLaveCo',
    'confirmUploadFileLLaveCo',
    'nameLLaveCo',
    'deleteLlaveCo',
    'dialog',
    'observerHCP',
  ],
  data() {
    return {
      length: 2,
      onboarding: 0,
    };
  },
};
</script>

<style>
.v-carousel__controls__item {
  color: grey !important;
}
</style>
